import { useState } from 'react';

export const useToolTip = () => {
  const [showToolTip, setShowToolTip] = useState(false);
  const toggleToolTip = (bool: boolean) => setShowToolTip(bool);
  return [showToolTip, toggleToolTip];
};
